import {
  Box,
  Button,
  Container,
  FormControl,
  Input,
  Text,
  Image,
  VStack,
  useToast,
  Flex,
  useDisclosure,
  HStack,
  FormErrorMessage,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import InputMask from 'react-input-mask'
import { ClientesModal } from './components/ClientesModal'
import { useClientesMutation } from './hooks/useClientesMutation'
import { FaUsers } from 'react-icons/fa'
import { useUser } from '../../../hooks/useUser'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

const cadastroSchema = z.object({
  nome: z.string().nonempty('Nome é obrigatório').min(3, 'Nome deve ter pelo menos 3 caracteres'),
  empresa: z.string().nonempty('Empresa é obrigatória').min(3, 'Empresa deve ter pelo menos 3 caracteres'),
  telefone: z
    .string()
    .nonempty('Telefone é obrigatório')
    .refine((val) => {
      const digitsOnly = val.replace(/\D/g, '')
      return digitsOnly.length >= 10 && digitsOnly.length <= 11
    }, 'Telefone inválido'),
  email: z.string().nonempty('E-mail é obrigatório').email('E-mail inválido'),
})
export const CadastroRapidoEventos = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(cadastroSchema),
    defaultValues: {
      cpf_cnpj: '',
      nome: '',
      empresa: '',
      telefone: '',
      email: '',
    },
  })
  const toast = useToast()
  const { mutate: cadastrarCliente, isLoading: isSubmitting } = useClientesMutation()

  const { codigo_usuario: codigoUsuario } = useUser()

  const onSubmit = async (data) => {
    const dadosFormatados = {
      nome_cliente: data.nome,
      nome_empresa: data.empresa || 'Não informado',
      email_cliente: data.email,
      celular_cliente: data.telefone.replace(/\D/g, ''),
      codigo_usuario: codigoUsuario,
    }

    cadastrarCliente(dadosFormatados, {
      onSuccess: (data) => {
        toast({
          title: 'Cadastro realizado!',
          description: 'Cliente cadastrado com sucesso.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        })
        reset()
      },
      onError: (error) => {
        toast({
          title: 'Erro ao cadastrar',
          description: error.message || 'Tente novamente mais tarde',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      },
    })
  }

  return (
    <Container p={0} maxW="md" centerContent>
      <Box w="100%" borderWidth="1px" borderRadius="lg" overflow="hidden" boxShadow="md">
        {/* Header */}
        <Box bg="#8CC63F" color="white" p={4} position="relative" borderTopRadius="lg" textAlign="center">
          <HStack justifyContent="space-between" mb={2}>
            <Text fontSize="xl" fontWeight="bold">
              Innovation Brindes!
            </Text>
            <Button leftIcon={<FaUsers />} size="sm" colorScheme="orange" onClick={onOpen} bg="#FF5722" color="white" _hover={{ bg: '#E64A19' }}>
              Ver Clientes
            </Button>
          </HStack>

          <Button mt={2} bg="#FF5722" color="white" size="md" _hover={{ bg: '#E64A19' }}>
            Tire suas dúvidas agora!
          </Button>

          {/* Profile Image */}
          <Flex justifyContent="center" mt={4}>
            <Box rounded="full" bg="white" size="120px" overflow="hidden" border="3px solid white" boxShadow="md" position="relative" zIndex={1}>
              <Image src="https://imgproductioncrm.s3.us-east-2.amazonaws.com/menino.png1741783264.5451" alt="Atendente" borderRadius="full" />
            </Box>
          </Flex>
        </Box>

        {/* Form Section */}
        <VStack spacing={4} p={4} bg="white">
          <Box p={4} borderWidth="1px" borderRadius="md" w="100%" bg="#f9f9f9">
            <Text>Olá, tudo bem?</Text>
          </Box>

          <Box p={4} borderWidth="1px" borderRadius="md" w="100%" bg="#f9f9f9">
            <Text>
              Irei fazer seu atendimento agora. Tudo o que você precisa fazer é apenas preencher os dados abaixo e estarei à sua disposição para
              ajudá-lo
            </Text>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <VStack spacing={4} align="stretch">
              <FormControl isInvalid={errors.nome}>
                <Input placeholder="Nome" {...register('nome', { required: true })} bg="white" border="1px solid #ddd" />

                <FormErrorMessage>{errors.nome && errors.nome.message}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={errors.empresa}>
                <Input placeholder="Empresa" {...register('empresa')} bg="white" border="1px solid #ddd" />

                <FormErrorMessage>{errors.empresa && errors.empresa.message}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={errors.telefone}>
                <Input
                  as={InputMask}
                  mask="(99) 99999-9999"
                  placeholder="Telefone"
                  {...register('telefone', { required: true })}
                  bg="white"
                  border="1px solid #ddd"
                />
                <FormErrorMessage>{errors.telefone && errors.telefone.message}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={errors.email}>
                <Input placeholder="E-mail" type="email" {...register('email', { required: true })} bg="white" border="1px solid #ddd" />
              </FormControl>

              <Button mt={4} colorScheme="green" bg="#8CC63F" isLoading={isSubmitting} type="submit" width="100%" _hover={{ bg: '#7AB532' }}>
                Salvar Contato
              </Button>
            </VStack>
          </form>
        </VStack>
      </Box>

      {/* Modal de Clientes */}
      <ClientesModal isOpen={isOpen} onClose={onClose} />
    </Container>
  )
}
